import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CorrelationIdService {
  //setto nel correlationId il correlation salvato nello storage
  correlationId = new BehaviorSubject<string>(
    localStorage.getItem('correlationId')
  );

  constructor() {}

  getCorrelationId() {
    return this.correlationId.asObservable();
  }

  setCorrelationId(value: string) {
    this.correlationId.next(value);
  }

  generateCorrelationId() {
    let result = '';
    //se il correlationId non esiste nello storage o è una stringa vuota lo genero
    if (this.correlationId.value === null || this.correlationId.value === '') {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
      const charactersLength = characters.length;

      let counter = 0;

      while (counter < 11) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
        counter += 1;
      }
      //salvo il correlationId generato nello storage
      localStorage.setItem('correlationId', result);
    } else {
      //se esiste nello storage utilizzo quello esistente
      result = this.correlationId.value;
    }

    this.correlationId.next(result);
    console.log('res: ' + result);
  }

  resetCorrelationId() {
    this.correlationId.next('');
  }
}
